const freeSessionValidators = {};

export default freeSessionValidators;
